export default __webpack_public_path__ + "components/outside-buttons/static/logos/outside-logo--white-7c6b844994fb70f3146f4857a7dd091b.svg";